// PARSE SHADER ERRORS
export {default as formatGLSLCompilerError, parseGLSLCompilerError} from './format-glsl-error';

// PARSE SHADER SOURCE
export {default as getShaderName} from './get-shader-name';
export {default as getShaderVersion} from './get-shader-version';

export {default as getShaderTypeName} from './get-shader-type-name';
